/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPartialShipmentManifestDetails.ts  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/partial-shipment-manifest-details";

export class AutogenModelPartialShipmentManifestDetails<RowType extends ModelRow> extends Endpoint<RowType, RowPartialShipmentManifestDetailsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPartialShipmentManifestDetails extends ModelRow<RowPartialShipmentManifestDetailsFields> {
	constructor(values?: Partial<RowPartialShipmentManifestDetailsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPartialShipmentManifestDetailsFields {
	actual_arrival: Date;
	actual_departure: Date;
	actual_reefer_profile: string;
	address: string;
	address2: string;
	agency_id: string;
	agent_payee_id: string;
	all_vendors_enabled: string;
	allow_relay: string;
	appointment_status_id: string;
	appt_contact_name: string;
	appt_required: string;
	autorate_status: string;
	bill_date: Date;
	bill_distance: number;
	bill_distance_um: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	bol_note: string;
	bol_received: string;
	bol_recv_date: Date;
	booking_no: string;
	booking_number: string;
	brk_qual_profile: string;
	broker_location_id: string;
	brokerage_workflow_id: string;
	carrier_scorecard_export_dt: Date;
	carrier_scorecard_exported: string;
	cases: number;
	cbp_crossing_date: Date;
	cbp_crossing_location_id: string;
	cbp_crossing_reason: string;
	cbsa_crossing_date: Date;
	cbsa_crossing_location_id: string;
	cbsa_crossing_reason: string;
	cc_fuel_revenue: number;
	cc_fuel_revenue_c: string;
	cc_fuel_revenue_d: Date;
	cc_fuel_revenue_n: number;
	cc_fuel_revenue_r: number;
	cc_net_revenue: number;
	cc_net_revenue_c: string;
	cc_net_revenue_d: Date;
	cc_net_revenue_n: number;
	cc_net_revenue_r: number;
	cc_pro_nbr: string;
	city_id: number;
	city_name: string;
	cobroker_location_id: string;
	collection_method: string;
	com_setpnt_temp: number;
	com_setpnt_temp_dt: Date;
	com_setpnt_temp_um: string;
	commitment_id: string;
	commodity: string;
	commodity_id: string;
	company_id: string;
	confirmed: string;
	consignee_refno: string;
	consignee_stop_id: string;
	contact_email: string;
	contact_name: string;
	container: string;
	container_planned: string;
	container_type_id: string;
	controlling_carrier_code: string;
	copy_from_company: string;
	copy_from_order_id: string;
	copy_to_company: string;
	copy_to_order_id: string;
	ctrl_party_id: string;
	cube: number;
	curr_movement_id: string;
	cust_order_no: string;
	customer_id: string;
	declared_val: number;
	def_move_type: string;
	default_match_id: string;
	dim_height: string;
	dim_length: string;
	dim_surcharge: number;
	dim_surcharge_c: string;
	dim_surcharge_d: Date;
	dim_surcharge_n: number;
	dim_surcharge_r: number;
	dim_width: string;
	dispatch_opt: string;
	dist_from_prev: number;
	dist_from_prev_um: string;
	dl_team_reqd: string;
	dray_del_date: Date;
	dray_del_pay: number;
	dray_del_pay_c: string;
	dray_del_pay_d: Date;
	dray_del_pay_n: number;
	dray_del_pay_r: number;
	dray_del_payee: string;
	dray_del_xfer_dt: Date;
	dray_pu_date: Date;
	dray_pu_pay: number;
	dray_pu_pay_c: string;
	dray_pu_pay_d: Date;
	dray_pu_pay_n: number;
	dray_pu_pay_r: number;
	dray_pu_payee: string;
	dray_pu_xfer_dt: Date;
	driver_load_unload: string;
	edi_code: string;
	edi_loc_code: string;
	eir1_no: string;
	eir2_no: string;
	entered_user_id: string;
	equipment_type_id: string;
	equipment_type_options: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	eta: Date;
	eta_distance: number;
	eta_late: string;
	eta_oor: string;
	excise_disable_update: string;
	excise_taxable: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	external_invoiceno: string;
	extra_deliveries: number;
	extra_pickups: number;
	floor_loaded_freight: string;
	force_assign: string;
	forwd_location_id: string;
	free_days: number;
	freight_charge: number;
	freight_charge_c: string;
	freight_charge_d: Date;
	freight_charge_n: number;
	freight_charge_r: number;
	google_place_id: string;
	grouped_id: number;
	hazmat: string;
	hazmat_code: string;
	high_value: string;
	hold_reason: string;
	hub: number;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	ic_stop_id: string;
	id: string;
	image_is_present: string;
	import_export: string;
	inbound_status: string;
	include_split_point: string;
	intelliset: string;
	invoice_recv_date: Date;
	is_auto_tonu: string;
	is_autorate_dist: string;
	is_container: string;
	is_dedicated: string;
	is_intercompany: string;
	is_local_mile: string;
	is_requested: string;
	is_tonu: string;
	jag_carrier_id: string;
	jag_cost_rate_id: number;
	late_eta_colorcode: string;
	late_route_status: string;
	latitude: number;
	ldport_location_id: string;
	linear_feet_avail: number;
	load_date: Date;
	loadboard: string;
	loadboard_post_movement_id: string;
	loadboard_posting_cancelled: string;
	location_id: string;
	location_name: string;
	lock_miles: string;
	longitude: number;
	ltl: string;
	manifest_fgp_uid: number;
	manifest_reg_uid: number;
	markup_flat: number;
	markup_flat_c: string;
	markup_flat_d: Date;
	markup_flat_n: number;
	markup_flat_r: number;
	markup_percent: number;
	master_order_id: string;
	master_sequence: number;
	move_dist_from_preassign: number;
	move_dist_from_preassign_um: string;
	move_dist_from_previous: number;
	move_dist_from_previous_um: string;
	movement_id: string;
	movement_sequence: number;
	next_rebill: string;
	nte_lp_num: string;
	nte_lp_qual: string;
	on_at_move_dest: string;
	on_at_move_origin: string;
	on_hold: string;
	operational_status: string;
	operations_user: string;
	optimize: string;
	optiset: string;
	order_id: string;
	order_mode: string;
	order_sequence: number;
	order_type_id: string;
	order_value: number;
	order_value_c: string;
	order_value_d: Date;
	order_value_n: number;
	order_value_r: number;
	ordered_by: string;
	ordered_by_id: string;
	ordered_date: Date;
	ordered_method: string;
	orig_dest_rate_id: string;
	orig_sched_early: Date;
	orig_sched_late: Date;
	otherchargetotal: number;
	otherchargetotal_c: string;
	otherchargetotal_d: Date;
	otherchargetotal_n: number;
	otherchargetotal_r: number;
	override_arrive_early: Date;
	override_arrive_late: Date;
	override_posting_city_id: number;
	pallets_dropped: number;
	pallets_how_many: number;
	pallets_picked_up: number;
	pallets_required: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	payment_code_reviewed: string;
	phone: string;
	pick_up_no: string;
	pieces: number;
	placard_required: string;
	planned_arrival_time: Date;
	planned_manifest_id: string;
	planning_comment: string;
	pnn_callback: string;
	pnn_comment: string;
	pnn_comment2: string;
	pnn_loadboard_user_id: string;
	pnn_post_type: string;
	pnn_rate: number;
	pnn_rate_type: string;
	pnn_trailer_length: number;
	pnn_trailer_width: number;
	ponum: string;
	port: string;
	port_of_discharge: string;
	preferred_vendors: string;
	preload_trailer_id: string;
	preloaded: string;
	prior_uncleared_stops: string;
	projected_arrival: Date;
	pu_override_arrive_early: Date;
	pu_override_arrive_late: Date;
	rate: number;
	rate_currency_type: string;
	rate_dist_from_previous: number;
	rate_dist_from_previous_um: string;
	rate_id: number;
	rate_min_weight: number;
	rate_min_weight_um: string;
	rate_source: string;
	rate_type: string;
	rate_unit_desc: string;
	rate_units: number;
	ready_to_bill: string;
	recurring_order_id: string;
	refno: string;
	reply_transmitted: string;
	requested_service: string;
	requesting_company: string;
	return_temp: number;
	return_temp_dt: Date;
	return_temp_um: string;
	return_temp_var: number;
	return_temp_var_um: string;
	revenue_code_id: string;
	revenue_share_method: string;
	round_trip: string;
	sail_date: Date;
	sched_arrive_early: Date;
	sched_arrive_late: Date;
	seal: string;
	seal_number: string;
	seg_alloc_code: string;
	sequence: number;
	service_date: Date;
	setpoint_temp: number;
	setpoint_temp_um: string;
	setpoint_var: number;
	setpoint_var_um: string;
	ship_status_to_edi: string;
	shipment_id: string;
	shipper_stop_id: string;
	shipstatus2edi_dt: Date;
	showas_address: string;
	showas_address2: string;
	showas_city_id: number;
	showas_city_name: string;
	showas_location_id: string;
	showas_location_name: string;
	showas_state: string;
	showas_zip_code: string;
	signed_for_name: string;
	ss_location_id: string;
	state: string;
	status: string;
	stop_type: string;
	subject_order_number: string;
	subject_order_status: string;
	subject_order_void_date: Date;
	swap: string;
	teams_required: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	temperature_um: string;
	total_charge: number;
	total_charge_c: string;
	total_charge_d: Date;
	total_charge_n: number;
	total_charge_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_type: string;
	trimble_place_id: string;
	txl_uid: number;
	vessel: string;
	vessel_cutoff_date: Date;
	voided_load_transmitted: string;
	voided_load_transmitted_dt: Date;
	volume: number;
	volume_um: string;
	weight: number;
	weight_um: string;
	xferred2billing: string;
	xferred2billing_dt: Date;
	zip_code: string;
	zone_id: string;
}

